import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M19 17H22L18 21L14 17H17V3H19V17ZM2 17H12V19H2V17ZM6 5V7H2V5H6ZM2 11H9V13H2V11Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SortDown"
);
